/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import Modal from "../components/Modal";
import Nav from "../components/Nav";

import { useLoadingStore, useStationsStore } from "../stores/hooks";

import { getColorsByLine } from "../utils/common";
/**
 * 기본 정보
 */
const DefaultInfoComponent = ({ routes, onExchangeStation }) => {
  const { ...loadingActions } = useLoadingStore();
  const { ...actions } = useStationsStore();

  const handleExchangeStation = async () => {
    if (!!routes?.length) {
      try {
        loadingActions.startLoading();
        onExchangeStation();

        const _data = {
          start_station_name: routes[0].dp_station_name,
          start_station_line: routes[0].dp_station_line,
          dp_station_name: routes[0].start_station_name,
          dp_station_line: routes[0].start_station_line,
        };

        const response = await actions.fetchRoutes(_data);

        if (response.status !== "Success") {
          window.alert(`경로 조회에 실패했습니다. 다시 시도해주세요.`);
        }
      } catch (e) {
        window.alert(`경로 조회에 실패했습니다. ${e.message}`);
      }

      loadingActions.finishLoading();
    }
  };

  return (
    <div className="bg-primary-6 p-16">
      <div className="max-w-[420px] w-full mx-auto bg-white rounded-16 border-1 border-gray-8">
        <SearchedStationComponent
          name={routes[0]?.start_station_name}
          type="start"
        />
        <div className="w-full h-1 relative px-12">
          <div className="w-full h-1 bg-gray-9"></div>
          <div className="w-1 h-45 absolute bg-primary-1 left-[27.5px] top-[-22px]" />
          <button
            type="button"
            className="p-6 bg-white border-1 border-gray-8 rounded-12 absolute left-12 top-[-16px] z-[10] hover:bg-gray-8 active:bg-gray-8"
            onClick={handleExchangeStation}
          >
            <img
              src="/assets/images/icon-switch.svg"
              alt="출발역과 도착역 변경"
              className="w-18"
            />
          </button>
        </div>
        <SearchedStationComponent
          name={routes[0]?.dp_station_name}
          type="end"
        />
      </div>
    </div>
  );
};

/**
 * 역 정보(검색)
 */
const SearchedStationComponent = ({ name, type }) => {
  const { state } = useStationsStore();

  const _station = name
    ? state?.stations?.find((station) => {
        if (name === "서울역") {
          return station.name === name;
        } else {
          return station.name === name?.replace(/(역)$/, "");
        }
      })
    : [];

  return (
    <div className="py-8 px-12 flex justify-start items-center">
      <div className="w-32 h-32 flex justify-center items-center">
        {type === "start" ? (
          <img src="/assets/images/icon-start.svg" alt="" />
        ) : (
          <img src="/assets/images/icon-end.svg" alt="" />
        )}
      </div>
      <div className="text-neutral-10 text-12 font-bold leading-[16px] tracking-[0.06px] flex-1">
        {name === "서울역" ? name : name?.replace(/(역)$/, "")}
      </div>
      <div className="flex justify-start items-center gap-2">
        {_station?.lines?.map((e) => (
          <div
            key={e}
            className={`h-24 min-w-24 py-2 px-8 rounded-12 text-10 font-bold tracking-[0.05px] flex justify-center items-center`}
            style={getColorsByLine(e, state.lines).style}
          >
            {e.replace(/^0+/, "").replace(/(호선|선)$/, "")}
          </div>
        ))}
      </div>
    </div>
  );
};

/**
 * 경로 카드
 */
const RouteCard = ({ route, onSelect }) => {
  const handleClickRoute = () => {
    onSelect(route);
  };

  return (
    <div
      className="p-24 hover:bg-primary-6 active:bg-gray-8 cursor-pointer"
      tabIndex={0}
      onClick={handleClickRoute}
    >
      <div className="mb-12">
        <div className="flex justify-start items-center text-gray-1 text-15 leading-[24px] tracking-[0.023px]">
          {/* <div>
            전체<b className="ml-8">-개 역</b>
          </div> 
          <div className="w-1 h-14 bg-gray-8 mx-8"></div>*/}
          <div>
            환승<b className="ml-4">{route.transfer?.total_count || 0}회</b>
          </div>
        </div>
        <div className="mt-10 flex justify-start items-center">
          <div className="rounded-12 bg-primary-6 py-4 px-12 flex justify-start items-center text-gray-1 text-10 leading-[20px] tracking-[0.025px]">
            <div>
              엘리베이터
              <b className="ml-4">{route.transfer?.elevator_count || 0}개</b>
            </div>
            <div className="w-1 h-10 bg-gray-8 mx-8"></div>
            <div>
              리프트<b className="ml-4">{route.transfer?.lift_count || 0}개</b>
            </div>
            {!!route.transfer?.total_duration &&
            route.transfer?.total_duration > 0 ? (
              <>
                <div className="w-1 h-10 bg-gray-8 mx-8"></div>
                <div>
                  환승 시간
                  <b className="ml-4">{route.transfer?.total_duration}분</b>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      <div className="grid gap-16">
        <StationComponent
          name={route.start_station_name}
          line={route.start_station_line}
        />
        {route.transfer?.transfer_list?.length &&
          route.transfer?.transfer_list.map((transfer, index) => {
            return (
              <StationComponent
                key={index}
                name={transfer.station_name}
                line={transfer.to_line}
              />
            );
          })}

        <StationComponent
          name={route.dp_station_name}
          line={route.dp_station_line}
          isDp={true}
        />
      </div>
    </div>
  );
};

/**
 * 역 (경로 목록 용)
 */
const StationComponent = ({ name, line, isDp = false }) => {
  const { lines } = useStationsStore().state;

  const refinedLine = line?.replace(/^0+/, "") || "";
  const keyColor = lines?.find(
    (e) => (e.name?.replace(/^0+/, "") || "") === refinedLine,
  )?.color;

  return (
    <div className="flex justify-start items-center">
      <div
        className="w-60 text-12 font-bold leading-[16px] tracking-[0.06px]"
        style={{ color: keyColor || "#49495A" }}
      >
        {line?.replace(/^0+/, "") || ""}
      </div>
      <div className="mx-16 relative">
        <div
          className="rounded-full w-10 h-10"
          style={{ backgroundColor: keyColor || "#49495A" }}
        />
        {!isDp && (
          <div
            className="w-2 h-14 absolute left-4 top-16"
            style={{ backgroundColor: keyColor || "#49495A" }}
          />
        )}
      </div>
      <div className="flex-1 text-gray-1 text-14 font-bold leading-[20px] tracking-[0.014px]">
        {name}
      </div>
    </div>
  );
};

/**
 * 경로 상세
 */

const groupConsecutiveActions = (actionsList) => {
  const result = [];
  let currentGroup = {
    action_type: actionsList[0]?.action_type,
    actions: [],
  };

  actionsList.forEach((action) => {
    if (action.action_type === currentGroup.action_type) {
      currentGroup.actions.push(action);
    } else {
      result.push(currentGroup);
      currentGroup = {
        action_type: action.action_type,
        actions: [action],
      };
    }
  });

  // 마지막 그룹 추가
  if (currentGroup.actions.length > 0) {
    result.push(currentGroup);
  }

  return result;
};

const RouteComponent = ({
  startStationName,
  dpStationName,
  line,
  // path = [],
  transferDetails,
  isExpress = false,
}) => {
  const { lines } = useStationsStore().state;

  // const [showPath, setShowPath] = useState(true);

  const refinedLine = line?.replace(/^0+/, "") || "";
  const keyColor = lines?.find(
    (e) => (e.name?.replace(/^0+/, "") || "") === refinedLine,
  )?.color;

  // const handleTogglePath = () => {
  //   setShowPath(!showPath);
  // };

  let transferDetailsList = [];
  if (transferDetails?.length) {
    transferDetailsList = [...transferDetails].sort(
      (a, b) => a.ts_order - b.ts_order,
    );
  }

  let actionsList = [];
  transferDetailsList?.forEach((td) => {
    let actions = [];
    if (td.actions?.length) {
      actions = [...td.actions]
        .sort((a, b) => a.action_order - b.action_order)
        .map((action, index) => {
          return {
            ...action,
            ts_location: td.ts_location,
            isFirst: index === 0,
          };
        });
    }

    actionsList = [...actionsList, ...actions];
  });

  const groupedActions = groupConsecutiveActions(actionsList);

  return (
    <div className="px-16">
      {/** 출발역 */}
      <div className="flex justify-start items-center">
        <div
          className="w-60 text-12 text-center font-bold leading-[16px] tracking-[0.06px]"
          style={{ color: keyColor || "#49495A" }}
        >
          {line?.replace(/^0+/, "") || ""}
        </div>
        <div className="mx-16 w-12 px-1 relative">
          <div
            className="rounded-full w-10 h-10"
            style={{ backgroundColor: keyColor || "#49495A" }}
          />
          <div
            className="w-2 h-14 absolute left-5 top-16"
            style={{ backgroundColor: keyColor || "#49495A" }}
          />
        </div>
        <div className="flex-1 text-gray-1 text-14 font-bold leading-[20px] tracking-[0.014px] flex justify-start items-center">
          <div className="flex justify-start items-center">
            {startStationName}
            {isExpress && (
              <div className="inline-flex items-center px-6 py-2 rounded-10 bg-[rgba(239,68,68,0.20)] border border-[rgba(239,68,68,0.30)] ml-5">
                <span className="text-[#ef4444] font-normal text-10 leading-[12px] tracking-[0.025px]">
                  급행
                </span>
              </div>
            )}
          </div>
          {/* <div className="w-1 h-10 bg-gray-8 mx-8"></div>
          <div className="text-gray-1 text-12 font-normal leading-[20px] tracking-[0.03px]">
            1개 역
          </div>
           <button type="button" onClick={handleTogglePath}>
            <img
              src="/assets/images/icon-arrow-up.png"
              alt="경로 보기"
              className={`w-16 h-16 ml-4 ${showPath ? "rotate-180" : ""}`}
            />
          </button> */}
        </div>
      </div>

      {/** 경로 목록 */}
      {/* {showPath &&
        path.map((e, index) => {
          return (
            <div key={index} className="flex justify-start items-center mt-16">
              <div className="w-60"></div>
              <div className="mx-16 w-12 px-3 relative">
                <div
                  className="rounded-full w-6 h-6"
                  style={{ backgroundColor: keyColor || "#49495A" }}
                />
                <div
                  className="w-2 h-16 absolute left-5 top-12"
                  style={{ backgroundColor: keyColor || "#49495A" }}
                />
              </div>
              <div className="flex-1 text-gray-1 text-10 leading-[20px] tracking-[0.025px]">
                {e.station_name}
              </div>
            </div>
          );
        })} */}

      {/** 도착역 */}
      <div className="flex justify-start items-center mt-16">
        <div className="w-60"></div>
        <div className="mx-16 w-12 px-1 relative">
          <div
            className="rounded-full w-10 h-10"
            style={{ backgroundColor: keyColor || "#49495A" }}
          />
        </div>
        <div className="flex-1 text-gray-1 text-14 font-bold leading-[20px] tracking-[0.014px]">
          {dpStationName}
        </div>
      </div>

      {/** 환승 상세 */}
      {groupedActions?.length > 0 && (
        <div className="mt-16 mx-[-16px] p-16 bg-primary-6 rounded-16 grid gap-8">
          {groupedActions.map((actionGroup, index) => {
            return (
              <TransferDetailComponent
                key={`groupedAction-${index}`}
                actionGroup={actionGroup}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

/**
 * 환승 상세
 */
const TransferDetailComponent = ({ actionGroup }) => {
  return (
    <div>
      <div className="flex justify-start items-start">
        <div className="w-60 relative">
          {actionGroup?.action_type === "엘리베이터" && (
            <ActionTypeComponent type="elevator" text="엘리베이터" />
          )}
          {actionGroup?.action_type === "리프트" && (
            <ActionTypeComponent type="lift" text="리프트" />
          )}
          {actionGroup?.action_type === "도보" && (
            <ActionTypeComponent type="move" text="이동" />
          )}
        </div>
        <div className="mx-16 w-12 px-1 relative"></div>
        <div className="flex-1 grid gap-8 pb-24 relative">
          <div className="route-line absolute left-[-20px] top-0">
            <div className="route-arrow absolute top-0 left-[-5px]" />
          </div>
          {actionGroup.actions?.map((action, index) => {
            return (
              <div key={`action-${action.action_id}-${index}`}>
                {action.isFirst && (
                  <div className="flex-1 text-gray-1 text-14 font-bold leading-[20px] tracking-[0.014px] mb-8">
                    {action.ts_location}
                  </div>
                )}
                <div className="flex-1 text-gray-1 text-12 leading-[20px] tracking-[0.03px]">
                  {action.description}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* <div className="flex justify-start items-start">

      
        
      </div>
      <div className="grid gap-8">
        {actionsList.map((e, index) => {
          return (
            <div
              key={`action_order-${e.action_order}`}
              className="flex justify-start items-start"
            >
              <div className="w-60 relative">
                {e.action_order > 1 &&
                  e.action_type !== actionsList[index - 1].action_type &&
                  e.action_type === "엘리베이터" && (
                    <ActionTypeComponent type="elevator" text="엘리베이터" />
                  )}
                {e.action_order > 1 &&
                  e.action_type !== actionsList[index - 1].action_type &&
                  e.action_type === "도보" && (
                    <ActionTypeComponent type="move" text="이동" />
                  )}
              </div>
              <div className="mx-16 w-12 px-1 relative">
                <div className="rounded-full w-10 h-10" />
              </div>
              <div className="flex-1 text-gray-1 text-12 leading-[20px] tracking-[0.03px]">
                {e.description}
              </div>
            </div>
          );
        })}
      </div> */}
    </div>
  );
};

/**
 * 환승 유형
 */
const ActionTypeComponent = ({ type, text }) => {
  return (
    <div className="">
      <img
        src={`/assets/images/route-${type}.svg`}
        alt=""
        className="mx-auto"
      />
      <div className="text-gray-2 text-10 leading-[20px] tracking-[0.025px] text-center">
        {text}
      </div>
    </div>
  );
};

function RoutesModal() {
  const { routes } = useStationsStore().state;
  const { ...actions } = useStationsStore();

  const [selectedRoute, setSelectedRoute] = useState(null);

  useEffect(() => {
    if (routes?.length === 1) {
      setSelectedRoute(routes[0]);
    }
  }, [routes]);

  const handleClose = () => {
    actions.reset();
  };

  const handleSelect = (route) => {
    setSelectedRoute(route);
  };

  const handleExchangeStation = () => {
    setSelectedRoute(null);
  };

  const handleClickPrev = () => {
    setSelectedRoute(null);
  };

  if (selectedRoute) {
    const transferList = selectedRoute.transfer?.transfer_list || [];

    return (
      <Modal>
        <Nav
          type="modal"
          title="경로 검색 결과"
          onClose={handleClose}
          prev={routes.length > 1}
          onPrev={handleClickPrev}
        />
        <div className="pt-56">
          {/**
           * 기본 정보
           */}
          <DefaultInfoComponent
            routes={routes}
            onExchangeStation={handleExchangeStation}
          />

          {/**
           * 경로 요약
           */}
          <div className="bg-primary-6 px-16 pb-16 border-b-1 border-gray-9">
            <div className="max-w-[420px] mx-auto">
              <div className="">
                <div className="flex justify-center items-center text-gray-1 text-15 leading-[24px] tracking-[0.023px]">
                  {/* <div>
                    전체<b className="ml-8">-개 역</b>
                  </div>
                  <div className="w-1 h-14 bg-gray-8 mx-8"></div> */}
                  <div>
                    환승
                    <b className="ml-4">
                      {selectedRoute.transfer?.total_count || 0}회
                    </b>
                  </div>
                </div>
                <div className="mt-8 flex justify-center items-center">
                  <div className="mt-8 rounded-12 bg-gray-9 py-4 px-8 flex justify-start items-center text-gray-1 text-10 leading-[20px] tracking-[0.025px]">
                    <div>
                      엘리베이터
                      <b className="ml-4">
                        {selectedRoute.transfer?.elevator_count || 0}개
                      </b>
                    </div>
                    <div className="w-1 h-10 bg-gray-8 mx-8"></div>
                    <div>
                      리프트
                      <b className="ml-4">
                        {selectedRoute.transfer?.lift_count || 0}개
                      </b>
                    </div>
                    {!!selectedRoute.transfer?.total_duration &&
                    selectedRoute.transfer?.total_duration > 0 ? (
                      <>
                        <div className="w-1 h-10 bg-gray-8 mx-8"></div>
                        <div>
                          환승 시간
                          <b className="ml-4">
                            {selectedRoute.transfer?.total_duration}분
                          </b>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                {selectedRoute.realtime_flag === "N" && (
                  <div className="text-center text-10 mt-10 text-gray-2">
                    본 노선도는 실시간 정보 제공 서비스로,
                    <br />
                    막차 종료 시 다음 날 오전 7시 기준으로 자동 조회됩니다.
                  </div>
                )}
              </div>
            </div>
          </div>

          {/**
           * 경로 상세
           */}
          <div className="bg-white px-16 py-24 min-h-[calc(100vh-320px)]">
            <div className="max-w-[420px] mx-auto">
              <div className="grid gap-16">
                {/** 출발역 */}
                <RouteComponent
                  startStationName={selectedRoute.start_station_name}
                  dpStationName={
                    !!transferList?.length
                      ? transferList[0].station_name
                      : selectedRoute.dp_station_name
                  }
                  line={selectedRoute.start_station_line}
                  transferDetails={
                    !!transferList?.length && transferList[0].transfer_details
                  }
                  isExpress={selectedRoute.start_express_yn === "Y"}
                  path={[]}
                />

                {/** 환승 경로 */}
                {transferList?.length > 1 &&
                  transferList.slice(1).map((transfer, index) => {
                    return (
                      <RouteComponent
                        key={index}
                        startStationName={transferList[index].station_name}
                        dpStationName={transfer.station_name}
                        line={transfer.from_line}
                        path={[]}
                        transferDetails={transfer.transfer_details}
                        isExpress={transfer.after_express_yn === "Y"}
                      />
                    );
                  })}

                {/** 도착역 */}
                {!!transferList?.length && (
                  <RouteComponent
                    startStationName={
                      transferList[transferList.length - 1].station_name
                    }
                    dpStationName={selectedRoute.dp_station_name}
                    line={transferList[transferList.length - 1].to_line}
                    path={[]}
                    isExpress={
                      transferList[transferList.length - 1].after_express_yn ===
                      "Y"
                    }
                  />
                )}
              </div>
            </div>
          </div>

          {/**
           * 제보하기
           */}
          <div className="bg-primary-6 py-24 px-16">
            <div className="max-w-[420px] mx-auto">
              <div className="flex justify-between items-center">
                <div className="flex-1 text-gray-2 text-10 leading-[20px] tracking-[0.025px]">
                  무의 교통약자 지도는 여러분의 제보로 함께 만들고 있습니다.
                  <br />
                  추가될 정보가 있다면 제보해주세요.
                </div>
                <a
                  href="https://forms.gle/WsJ7PdSEiC6d4X9Y8"
                  alt=""
                  target="_blank"
                  rel="noreferrer"
                >
                  <button
                    type="button"
                    className="ml-8 py-7 px-10 rounded-12 bg-primary-1 text-white text-12 font-bold leading-[16px] tracking-[0.06px]"
                  >
                    제보하기
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  return (
    <Modal>
      <Nav type="modal" title="경로 검색 결과" onClose={handleClose} />
      <div className="pt-56">
        {/**
         * 기본 정보
         */}
        <DefaultInfoComponent
          routes={routes}
          onExchangeStation={handleExchangeStation}
        />

        {/**
         * 경로 목록
         */}
        <div className="grid divide-y-1 divide-gray-9">
          {routes?.map((route, index) => {
            return (
              <RouteCard key={index} route={route} onSelect={handleSelect} />
            );
          })}
        </div>
      </div>
    </Modal>
  );
}

export default RoutesModal;
